import {Component, Input, OnInit} from '@angular/core';
import {isNullOrUndefined} from 'util';
import {PROFILE_TYPE} from '../../../../../../../../common/constants';
import {KYCDirectorOrShareholder} from "../../../api/entity/kyc-verification";


export type KYCResultsBlockField = {
    translateKey: string;
    value: string | number;
}

@Component({
    selector: 'tfl-bo-kyc-results-block',
    host: {'class': 'verification-results-block'},
    template: `
        <div class="row">
            <div class="col-sm-12">
                <div class="x_panel">

                    <div class="x_title">
                        <h4>{{ title }}
                            <ng-container *ngIf="profileBadge" [ngSwitch]="profileType">
                                <span *ngSwitchCase="PROFILE_TYPE.CORPORATE"
                                      class="label label-primary">
                                    {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.CORPORATE' | translate }}
                                </span>
                                <span *ngSwitchCase="PROFILE_TYPE.PRIVATE"
                                      class="label label-success">
                                    {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.INDIVIDUAL' | translate }}
                                </span>
                            </ng-container>
                        </h4>

                        <tfl-bo-kyc-status-badge
                            *ngIf="result"
                            [status]="result.status.result">
                        </tfl-bo-kyc-status-badge>
                    </div>

                    <div *ngIf="fields" class="x_content">
                        <div class="row">
                            <div *ngFor="let field of fields" class="col-xs-12 col-md-6">
                                <div class="row">
                                    <div class="col-xs-6 result-field-title">
                                        {{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.' + field.translateKey | translate }}:
                                    </div>
                                    <div class="col-xs-6">{{ field.value }}</div>
                                </div>
                            </div>
                        </div>
                        <a [href]="getDetailsLink()" class="result-details-link" target="_blank">
                            {{ 'CUSTOMER.VERIFICATION.BLOCK.DETAILS' | translate }}
                        </a>
                    </div>

                    <div *ngIf="!fields" class="verification-results-block-inner">
                        <ng-content></ng-content>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class KycResultsBlockComponent implements OnInit {

    @Input() title: string;
    @Input() result: KYCDirectorOrShareholder;
    @Input() profileBadge = false;

    fields: KYCResultsBlockField[];
    profileType: PROFILE_TYPE;

    readonly PROFILE_TYPE = PROFILE_TYPE;

    ngOnInit(): void {
        if (this.result) {
            this.profileType = this.getProfileType();
            this.initFields();
        }
    }

    getDetailsLink() {
        const profile = this.result.person || this.result.company;
        return profile.link || '';
    }

    private initFields() {
        if (this.profileType == PROFILE_TYPE.CORPORATE) {
            this.fields = [
                {translateKey: 'COMPANY_NAME', value: this.result.company.name},
                {translateKey: 'REG_NUMBER', value: this.result.company.registration_number},
                {translateKey: 'COMPANY_TYPE', value: this.result.company.type},
                {translateKey: 'REG_OFFICE_COUNTRY', value: this.result.company.registered_office_country},
                {translateKey: 'VERIFICATION_DATE', value: this.result.status.verification_date}
            ];
        }
        if (this.profileType == PROFILE_TYPE.PRIVATE) {
            this.fields = [
                {translateKey: 'FIRST_NAME', value: this.result.person.first_name},
                {translateKey: 'DOB', value: this.result.person.dob},
                {translateKey: 'LAST_NAME', value: this.result.person.last_name},
                {translateKey: 'NATIONALITY', value: this.result.person.nationality},
                {translateKey: 'VERIFICATION_DATE', value: this.result.status.verification_date},
                {translateKey: 'ADDRESS', value: this.result.person.address}
            ];
        }
    }

    private getProfileType(): PROFILE_TYPE {
        return !isNullOrUndefined(this.result.company) ? this.PROFILE_TYPE.CORPORATE :
            !isNullOrUndefined(this.result.person) ? this.PROFILE_TYPE.PRIVATE : undefined;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/kyc/results/kyc-results.block.component.ts